module.exports = __webpack_public_path__ + "static/media/eina04-semibold.bc0124f5.woff2";